import type { PatternFormFieldItem } from '@ricoh/ria.client.core/types/component/pattern.type';
import type { ExtractStrict } from '@ricoh/ria.client.core/types/core/utility.type';

import { isNull } from '@ricoh/ria.client.core/utils/data/object';

import type { PatternConstant } from '~/common/model/api/batch-type/pattern';

import commonLogic from '~/common/logic/common';

/**
 * Format PatternConstant.
 *
 * @param {PatternConstant} pattern PatternConstant.
 *
 * @returns {string} Format PatternConstant.
 */
export function formatPatternConstant(pattern: PatternConstant): string {
  if (isNull(pattern.value)) {
    return '';
  }

  if (Array.isArray(pattern.value)) {
    return pattern.value
      .map((item) => {
        if (isNull(item)) {
          return '';
        }

        if (typeof item === 'object') {
          return JSON.stringify(Object.values(item).map((value) => commonLogic.data.formatDataValue(value, ['true', 'false'])));
        }

        return item?.toString();
      })
      .join(', ');
  }

  return pattern.value.toString();
}

/** Create PatternConstant. */
export const createPatternConstant = {
  text: (value: string): PatternConstant => ({
    $is: 'const',
    type: 'text',
    value,
  }),
};

/** Create PatternConstant FormField. */
export const createPatternConstantFormField = {
  text: (pattern: PatternConstant): ExtractStrict<PatternFormFieldItem, string> => formatPatternConstant(pattern),
};
